import { render, staticRenderFns } from "./LiveBro.vue?vue&type=template&id=708c9d3c&scoped=true"
import script from "./LiveBro.vue?vue&type=script&lang=js"
export * from "./LiveBro.vue?vue&type=script&lang=js"
import style0 from "./LiveBro.vue?vue&type=style&index=0&id=708c9d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c9d3c",
  null
  
)

export default component.exports